<template>
  <div class="list-item layout text-primary lh-copy" :class="{ 'ba bw1 b--accent': highlight }">
    <div class="layout-header f6">
      <div>
        <span class="db ttu">Процедура</span>
        <span class="db"><span class="text-secondary f6 mr2">ID</span>{{ proc.id }}</span>
      </div>
      <div>
        <span class="db text-secondary">создана</span>
        <span class="db">{{ format(proc.dateCreated) }}</span>
      </div>
    </div>
    <span class="bb br-l b--near-white"></span>
    <div class="layout-main f6">
      <div class="flex flex-row justify-between">
        <div class="ttu text-accent f7">
          {{ statuses[proc.stateId].name }}
        </div>
        <div v-if="proc.stage" class="ttu text-accent f7">
          этап: {{ proc.stage.stage }}
        </div>
      </div>
      <router-link :to="{ name: 'procedure_card', params: { id: proc.id } }" class="link text-primary underline b f5 lh-copy mv2">
        <span class="text-wrap">{{ proc.title }}</span>
      </router-link>
      <div class="">
        <span class="db text-secondary">менеджер</span>
        <span class="db f6">{{ manager }}</span>
      </div>
    </div>
    <span class="bb br-l b--near-white"></span>
    <div class="layout-footer f6">
      <span title="Кол-во зарегистрированных участников">участников</span><span class="layout-footer-measure">{{ formatNumber(proc.participantsCount) }}</span>
      <!--
      <span title="Просмотры зарегистрированными участниками">просмотров</span><span class="layout-footer-measure">{{ formatNumber(proc.viewedCount) }}</span>
      ниже заглушка
      -->
      <span>товаров</span><span class="layout-footer-measure">{{ formatNumber(proc.productCount) }}</span>
      <span></span><span></span>
      <span>рейтинг</span><span class="layout-footer-measure">{{ proc.rating ? proc.rating : '-' }}</span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { humanizeDuration } from '@/plugins/consts.js'
import { momentFromString } from '@/utils/datetime.js'
import { expiredAgreement, expiredRating, minBidCountNotReached } from '@/utils/procedure.js'

const moment = require('moment')
moment.locale('ru')

export default {
  props: ['proc', 'highlight'],
  computed: {
    ...mapGetters('companyInfo', ['managers']),
    ...mapGetters('procedure', ['bid_directions', 'statuses']),
    manager () {
      return this.managersMap()[this.proc.manager]?.name || ''
    },
    expiredAgreement () {
      return expiredAgreement(this.proc)
    },
    expiredRating () {
      return expiredRating(this.proc)
    },
    minBidCountNotReached () {
      return minBidCountNotReached(this.proc)
    }
  },
  methods: {
    format (dt) {
      return momentFromString(dt)?.format('DD.MM.YYYY')
    },
    formatNumber (number) {
      return number && +number > 0 ? number : 0
    },
    duration (proc) {
      if (proc.dateClosed) {
        return humanizeDuration(momentFromString(proc.dateOpen), momentFromString(proc.dateClosed))
      } else if (proc.dateOpen) {
        return humanizeDuration(momentFromString(proc.dateOpen), moment())
      } else {
        return null
      }
    },
    managersMap () {
      return Object.fromEntries(this.managers?.map(man => ([man.id, man]) || []))
    }
  }
}
</script>

<style lang="scss" scoped>
.layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 100px 2px 1fr px 100px;
  grid-row-gap: .5rem;
  &-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  &-main {
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto 1fr auto;
    padding: .25rem 0rem .25rem 0rem;
  }
  &-footer {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: 1.2rem 1.2rem 1fr 1.2rem;
    grid-column-gap: .25rem;
    grid-row-gap: 0rem;
    padding: .25rem 0rem .25rem 0rem;
    &-measure{
      justify-self: end;
    }
  }
}
@media screen and (min-width: 80em) {
  .layout {
    display: grid;
    grid-template-columns: 100px 2px 1fr  2px 170px;
    grid-template-rows: auto;
    grid-column-gap: .25rem;
    &-header {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    &-main {
      display: grid;
      grid-template-columns: auto;
      grid-template-rows: auto 1fr auto;
      padding: 0rem 1rem 0rem 1rem;
    }
    &-footer {
      display: grid;
      grid-template-columns: 1fr auto;
      // grid-template-rows: 1.5rem 1.5rem 1.5rem 1fr 1.5rem;
      grid-template-rows: 1.5rem 1.5rem 1fr 1.5rem;
      grid-column-gap: .25rem;
      grid-row-gap: .25rem;
      padding: 0rem 1rem 0rem 1rem;
      &-measure{
        justify-self: end;
      }
    }
  }
}
</style>
